import { type CreateBlockData } from '@/lib/builder/types'

import {
  type ReviewsSectionCreate,
  type ReviewsSection,
} from '../../../WebsiteBuilder.types'

export const createReviewsData = ({
  brandId,
}: CreateBlockData<ReviewsSection>): ReviewsSectionCreate => ({
  brandId,
  params: {
    image: null,
    layout: 'generic',
    reviews: [
      {
        comment:
          'Pulvinar elementum integer enim neque volutpat. Nam libero justo laoreet sit. Dignissim enim sit amet venenatis. Vulputate enim nulla aliquet porttitor.',
        name: 'John D.',
        stars: 5,
      },
      {
        comment:
          'Commodo ullamcorper a lacus vestibulum sed. Nulla pellentesque dignissim enim sit amet venenatis urna. Tortor posuere ac ut consequat. Volutpat ac tincidunt vitae semper quis lectus nulla at.',
        name: 'Jane D.',
        stars: 5,
      },
      {
        comment:
          'Eget nunc lobortis mattis aliquam. Malesuada proin libero nunc consequat interdum varius. Vitae justo eget magna fermentum iaculis eu.',
        name: 'Chad M.',
        stars: 5,
      },
    ],
  },
  type: 'reviews',
})
